import { create } from 'zustand';

import { Cookie } from '@libs/common-next';

interface OverrideStore {
    overrides: Record<string, string | boolean>;
    setOverride: (override: Record<string, string | boolean>) => void;
    toggleFilter: (state: boolean) => void;
    filter: boolean;
}
export const useOverrides = create<OverrideStore>(set => ({
    overrides: JSON.parse(Cookie.get('x-petm-override') ?? '{}'),
    setOverride: overrides => set({ overrides }),
    toggleFilter: (filter: boolean) => set({ filter }),
    filter: false,
}));

interface FilterStore {
    category: 'ab' | 'ff' | 'control' | 'all';
    setCategory: (category: FilterStore['category']) => void;
}
export const useFilters = create<FilterStore>(set => ({
    category: 'all',
    setCategory: category => set({ category }),
}));
